import React from 'react';
import GetInTouchFormPage from '../b2b/GetInTouchFormPage';

const Support: React.FC = () => {
  return (
    <div className='space-y-6'>
      <GetInTouchFormPage
        title='Need Help?'
        paragraph={`We're here for you! Contact us with any questions or technical issues, and we'll be happy to assist`}
      />

      {/* Business+ Dedicated Account Manager Section */}
      <div className='mt-8 mx-auto primary-shadow border border-gray-200 rounded-lg bg-gray-50'>
        <div className='p-8'>
          <h3 className='text-xl font-semibold text-gray-800 mb-4'>
            Business+ Dedicated Account Manager
          </h3>
          <p className='text-gray-600 mb-6 leading-relaxed'>
            Need additional in-person support? Schedule a 30-min call with your dedicated{" "}
            <strong>Success Manager</strong>.
          </p>
          <button
            onClick={() =>
              window.open(
                'https://calendar.app.google/k2uXhAHsz551eCBU9',
                '_blank'
              )
            }
            className='bg-primary text-white px-8 py-3 rounded-lg font-semibold transition-colors duration-200 shadow-md hover:shadow-lg'
          >
            Schedule a Call
          </button>
        </div>
      </div>
    </div>
  );
};

export default Support;
